import moment from "moment-timezone";
import { useI18n } from "vue-i18n";

const zeroPadLeft = number => {
 if (number.toString().length === 1) {
   return "0" + number;
 } else {
   return number;
 }
};

function getCurrentLocale(app) {
  return app.config.globalProperties.$i18n?.locale || "da";
}


export default {
 install: function(app) {
   app.config.globalProperties.$moment = moment;

   app.config.globalProperties.$filters = {
     momentTime: function(value) {
      const locale = getCurrentLocale(app);
       return moment
         .utc(value)
         .tz("Europe/Copenhagen")
         .format("HH:mm");
     },
     momentDate: function(value) {
      const locale = getCurrentLocale(app);
       return moment
         .utc(value)
         .tz("Europe/Copenhagen")
         .format("D. MMMM YYYY");
     },
     momentDateAndTime: function(value) {
      const locale = getCurrentLocale(app);
       return moment
         .utc(value)
         .tz("Europe/Copenhagen")
         .format("D. MMMM YYYY HH:mm");
     },
     momentMonthYear: function(value) {
      const locale = getCurrentLocale(app);
       return moment
         .utc(value)
         .tz("Europe/Copenhagen")
         .format("MMMM YYYY");
     },
     momentFull: function(value) {
      const locale = getCurrentLocale(app);
       return moment
         .utc(value)
         .tz("Europe/Copenhagen")
         .format("dddd D. MMMM YYYY");
     },
     momentFullCapitalFirstLetter(value, locale = "da") {
      if (!value) return "";
    
      const full = moment
        .utc(value)
        .tz("Europe/Copenhagen")
        .locale(locale) 
        .format("dddd D. MMMM YYYY");
    
      return full.charAt(0).toUpperCase() + full.slice(1);
    },
     tripTravelTime: function(trip) {
       const fromDate = moment.utc(trip.departureInstant);
       const toDate = moment.utc(trip.arrivalInstant);
       const minuteDiff = toDate.diff(fromDate, "minutes");
       const hourDuration = Math.floor(minuteDiff / 60);
       const minuteDuration = minuteDiff % 60;
       return [
         zeroPadLeft(hourDuration),
         zeroPadLeft(minuteDuration)
       ].join(":");
     },
   };
 }
};

export function minuteToNiceString (value) {
  const { tm } = useI18n()
  const txts = tm("filter_moment");

  let minutes = value;
  let days = Math.floor(minutes / 60 / 24);
  minutes = minutes - days * 24 * 60;
  let hours = Math.floor(minutes / 60);
  minutes = minutes - hours * 60;

  const parts = [];
  if (days > 0)
    parts.push(`${days} ${days === 1 ? txts.day : txts.days}`);
  if (hours > 0)
    parts.push(`${hours} ${hours === 1 ? txts.hour : txts.hours}`);
  if (minutes > 0)
    parts.push(
      `${minutes} ${minutes === 1 ? txts.minute : txts.minutes}`
    );

  return parts.join(", ").replace(/,([^,]*)$/, " &" + "$1");
}